export const siteNav = [
  { label: "今日首发", href: "#cover" },
  { label: "实时快讯", href: "#briefing" },
  { label: "话题墙", href: "#topics" },
  { label: "合集索引", href: "#collections" },
  { label: "吃瓜热榜", href: "#ranking" },
];

export const utilityBar = {
  date: "2026.09.12 周六",
  status: "编辑部在线",
  note: "全网内容持续收录中",
};

export const tickerItems = [
  "今日首发｜某热播剧片场花絮流出，网友直呼信息量有点大",
  "快讯｜头部主播直播中途关播，粉丝群讨论持续升温",
  "更新｜选秀综艺成团名单疑似提前曝光，话题阅读量破亿",
  "热议｜某品牌代言临时更换海报，评论区排队围观",
  "快讯｜音乐节彩排路透流出，现场秩序一度混乱",
  "新料｜都市剧官微深夜删帖，被眼尖网友截图留存",
];

export const coverStory = {
  kicker: "本期封面 · 首发",
  title: "深夜删帖之后：一档爆款综艺的口碑反转始末",
  excerpt:
    "从路透流出到官微连夜修改，短短六小时里，话题墙被同一组关键词刷屏。我们把公开可见的时间线重新梳理了一遍，还原这次讨论为什么会越滚越大。",
  image:
    "https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20aesthetic%2C%20dramatic%20deep%20crimson%20silk%20curtain%20backdrop%20with%20a%20vintage%20microphone%20and%20scattered%20folded%20newspapers%2C%20warm%20cinematic%20rim%20light%2C%20grainy%20analog%20film%20texture%2C%20high%20contrast%2C%20moody%20sophisticated%20atmosphere%2C%20negative%20space%20at%20top&width=1000&height=1300&seq=hlwp-cover-01&orientation=portrait",
  readTime: "8 分钟读完",
  views: "12.4 万",
  tags: ["首发", "口碑反转", "时间线"],
  reporters: "编辑部 · 深度组",
};

export const coverGuide = [
  { no: "01", time: "09:42", title: "删帖六小时：官微改了哪几句话", tag: "首发" },
  { no: "02", time: "10:15", title: "三张路透图，如何串起整条时间线", tag: "图解" },
  { no: "03", time: "11:03", title: "粉丝与路人各执一词，评论区在吵什么", tag: "热议" },
  { no: "04", time: "12:28", title: "品牌方沉默背后：合作细节被重新翻出", tag: "追踪" },
  { no: "05", time: "13:50", title: "同档期综艺为何突然被拿来对比", tag: "延伸" },
];

export const guideTag = { name: "本轮话题", value: "深夜删帖" };

export const briefingItems = [
  { time: "08:51", text: "某都市剧片场路透流出，服化道成讨论焦点", tag: "新料" },
  { time: "09:12", text: "选秀综艺成团夜预告释出，十分钟播放破千万", tag: "快讯" },
  { time: "09:40", text: "头部主播直播间突然黑屏，运营回应设备故障", tag: "追踪" },
  { time: "10:05", text: "音乐节主办方临时调整入场动线，观众排队超一小时", tag: "现场" },
  { time: "10:33", text: "某品牌更换官网首图，旧海报被网友对比存档", tag: "热议" },
  { time: "11:07", text: "演员工作室发文辟谣，评论区热度不降反升", tag: "回应" },
  { time: "11:46", text: "短视频平台上线新的话题标签，24 小时新增讨论过万", tag: "数据" },
  { time: "12:20", text: "某综艺常驻阵容微调，知情网友晒出录制合影", tag: "新料" },
  { time: "13:02", text: "片方发布首支正式预告，弹幕清一色在抠细节", tag: "首发" },
  { time: "13:35", text: "同款周边预售开启，几分钟内显示补货中", tag: "延伸" },
  { time: "14:11", text: "某社交账号被发现悄悄清空动态，引发新一轮猜测", tag: "热议" },
  { time: "14:49", text: "专访片段提前流出，被剪掉的一句话成关键词", tag: "追踪" },
];

export const topics = [
  { name: "深夜删帖", heat: "热" },
  { name: "片场路透", heat: "新" },
  { name: "成团名单", heat: "" },
  { name: "口碑反转", heat: "热" },
  { name: "直播黑屏", heat: "" },
  { name: "代言更换", heat: "新" },
  { name: "音乐节现场", heat: "" },
  { name: "预告解析", heat: "" },
  { name: "工作室回应", heat: "热" },
  { name: "周边补货", heat: "" },
  { name: "时间线整理", heat: "" },
  { name: "弹幕名场面", heat: "新" },
  { name: "同档期对比", heat: "" },
  { name: "评论区观察", heat: "" },
  { name: "路透九宫格", heat: "" },
  { name: "深夜发文", heat: "热" },
  { name: "剪辑争议", heat: "" },
  { name: "粉黑大战", heat: "" },
];

export const collections = [
  {
    id: 1,
    title: "本周话题合集",
    count: "46 条",
    desc: "把这一周被反复讨论的片段、截图与回应，按时间顺序收在一处。",
    tag: "合集",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20vintage%20newspapers%20and%20a%20confidential%20manila%20envelope%20on%20a%20warm%20cream%20paper%20surface%2C%20deep%20red%20wax%20seal%20accent%2C%20cinematic%20soft%20shadows%2C%20grainy%20film%20texture%2C%20high%20contrast%2C%20minimal%20sophisticated%20composition&width=520&height=640&seq=hlwp-col-01&orientation=portrait",
  },
  {
    id: 2,
    title: "深夜档追踪档案",
    count: "23 条",
    desc: "那些发生在凌晨、第二天才被翻出来的讨论，都在这一份档案里。",
    tag: "追踪",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20portrait%20of%20a%20silhouetted%20figure%20backlit%20by%20warm%20amber%20stage%20light%20behind%20a%20translucent%20curtain%2C%20deep%20crimson%20tones%2C%20grainy%20analog%20film%20texture%2C%20cinematic%20high%20contrast%2C%20mysterious%20elegant%20mood&width=520&height=640&seq=hlwp-col-02&orientation=portrait",
  },
  {
    id: 3,
    title: "首发快照存档",
    count: "58 条",
    desc: "抢在被修改之前截下来的页面、海报与预告，都做了编号留存。",
    tag: "首发",
    image:
      "https://readdy.ai/api/search-image?query=Studio%20still%20life%20of%20a%20retro%20film%20camera%20and%20scattered%20instant%20photos%20on%20warm%20beige%20linen%2C%20deep%20red%20ribbon%20accent%2C%20cinematic%20soft%20shadow%2C%20grainy%20film%20texture%2C%20editorial%20magazine%20aesthetic&width=520&height=640&seq=hlwp-col-03&orientation=portrait",
  },
];

export const storyCards = [
  {
    id: 1,
    title: "城市夜里的热搜：霓虹与雨水之间的一夜",
    excerpt: "路透、截图、路人视角，被拼成同一条时间线，越看越有细节。",
    tag: "现场",
    time: "25 分钟前",
    source: "快讯组",
    image:
      "https://readdy.ai/api/search-image?query=Night%20city%20skyline%20reflected%20on%20wet%20asphalt%20with%20neon%20warm%20red%20signs%20blurred%20in%20bokeh%2C%20cinematic%20editorial%20photography%2C%20grainy%20film%20texture%2C%20high%20contrast%2C%20moody%20atmosphere&width=640&height=420&seq=hlwp-card-01&orientation=landscape",
  },
  {
    id: 2,
    title: "一部手机搅动的话题夜",
    excerpt: "深夜发帖、清晨删除，中间那几小时的评论区被反复截图。",
    tag: "热议",
    time: "48 分钟前",
    source: "观察组",
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20smartphone%20screen%20glowing%20in%20a%20dark%20room%20held%20by%20a%20hand%2C%20warm%20red%20ambient%20light%2C%20editorial%20magazine%20aesthetic%2C%20grainy%20film%20texture%2C%20high%20contrast%2C%20mysterious%20mood&width=640&height=420&seq=hlwp-card-02&orientation=landscape",
  },
  {
    id: 3,
    title: "后台化妆间的那盏灯，为什么被反复提起",
    excerpt: "一张随手拍的照片，牵出了整档节目的排班与站位。",
    tag: "追踪",
    time: "1 小时前",
    source: "追踪组",
    image:
      "https://readdy.ai/api/search-image?query=Empty%20backstage%20dressing%20room%20with%20lit%20vanity%20mirror%20bulbs%20and%20a%20hanging%20costume%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20editorial%20photography%2C%20grainy%20film%20texture%2C%20high%20contrast&width=640&height=420&seq=hlwp-card-03&orientation=landscape",
  },
  {
    id: 4,
    title: "发布会之外：那些被拦住的问题",
    excerpt: "现场提问被匆匆收尾，散场后同行之间还在交换笔记。",
    tag: "首发",
    time: "2 小时前",
    source: "现场组",
    image:
      "https://readdy.ai/api/search-image?query=Crowd%20of%20reporters%20holding%20vintage%20microphones%20and%20cameras%20at%20a%20press%20event%2C%20warm%20cinematic%20light%2C%20deep%20red%20accent%2C%20editorial%20magazine%20aesthetic%2C%20grainy%20film%20texture%2C%20high%20contrast&width=640&height=420&seq=hlwp-card-04&orientation=landscape",
  },
  {
    id: 5,
    title: "九宫格之外，被忽略的第九张图",
    excerpt: "同一批图里最不起眼的那张，反倒藏着最多可以核对的信息。",
    tag: "图解",
    time: "3 小时前",
    source: "图解组",
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20opened%20notebooks%2C%20a%20fountain%20pen%20and%20a%20coffee%20cup%20on%20a%20warm%20cream%20desk%2C%20dramatic%20side%20light%2C%20grainy%20film%20texture%2C%20editorial%20magazine%20aesthetic%2C%20high%20contrast&width=640&height=420&seq=hlwp-card-05&orientation=landscape",
  },
  {
    id: 6,
    title: "谢幕之后，讨论才刚刚开始",
    excerpt: "灯光亮起的瞬间被拍下，评论区的情绪也跟着变了方向。",
    tag: "热议",
    time: "4 小时前",
    source: "编辑部",
    image:
      "https://readdy.ai/api/search-image?query=Curtain%20call%20on%20a%20theatre%20stage%20with%20red%20velvet%20curtains%20and%20warm%20spotlight%20beams%2C%20editorial%20magazine%20aesthetic%2C%20grainy%20film%20texture%2C%20cinematic%20high%20contrast%2C%20elegant%20dramatic%20mood&width=640&height=420&seq=hlwp-card-06&orientation=landscape",
  },
];

export const hotRanking = [
  { rank: 1, title: "深夜删帖事件完整时间线", heat: "986 万", trend: "up" },
  { rank: 2, title: "成团名单疑似提前曝光", heat: "742 万", trend: "up" },
  { rank: 3, title: "头部主播直播黑屏三分钟", heat: "610 万", trend: "new" },
  { rank: 4, title: "代言海报连夜更换", heat: "538 万", trend: "down" },
  { rank: 5, title: "音乐节入场动线调整", heat: "471 万", trend: "up" },
  { rank: 6, title: "预告片里被剪掉的那句话", heat: "402 万", trend: "new" },
  { rank: 7, title: "工作室深夜发文回应", heat: "366 万", trend: "up" },
  { rank: 8, title: "同档期综艺被拿来对比", heat: "298 万", trend: "down" },
];

export const sideNote = {
  title: "编辑手记",
  lines: [
    "今天的讨论从凌晨的一条动态开始，六小时后仍在延续。",
    "我们把可核对的部分单独列了出来，方便你随时回头翻。",
    "如果你手上也有线索，欢迎通过下方入口递给我们。",
  ],
};

export const footerColumns = [
  { title: "浏览", links: ["今日首发", "实时快讯", "话题墙", "合集索引"] },
  { title: "内容", links: ["首发快照", "追踪档案", "图解专区", "热榜回顾"] },
  { title: "关于", links: ["关于我们", "收录标准", "纠错反馈", "合作联系"] },
];